import React, { useEffect, useState } from 'react';
import SkeletonLoader from '../../../../generic/Utils/SkeletonLoader';
import ChronusApi from "../../../../../services/ChronusApi";
import AssessmentPrompt from '../../../PurposeAssessment/Prompts/Index';

const SideBarPromotion = ({promotionContentUrl}) => {
  const [isPromotionContentLoading, setIsPromotionContentLoading] = useState(true);
  const [promotionContent, setPromotionContent] = useState(null);

  useEffect(() => {
    ChronusApi.getUrlJSON(promotionContentUrl).then((response)=>{
      setPromotionContent(response);
      setIsPromotionContentLoading(false);
    });
  }, []);

  return (
    <div>
      {
        isPromotionContentLoading ? <SkeletonLoader times={1} /> : <AssessmentPrompt promptData={promotionContent} />
      }
    </div>
  )
}

export default SideBarPromotion;
